import { Effect } from 'effect';

import { brandsPerPageDefault } from '@vs-shop/engine/config/brands';

import { requestBrands } from '../../bind/brand';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';
import { tagged } from '@vs-shop/engine/data/util/tagged';

// Define a Data.tagged type for type-safe atom keys with Equal implementation
type FetchBrandsKey = {
  readonly _tag: 'FetchBrandsKey';
  readonly page: number;
  readonly alphabetFilter: string | null;
  readonly searchFilter: string | null;
};

const FetchBrandsKey = tagged<FetchBrandsKey>('FetchBrandsKey');

// ✅ WORKING: Data.tagged provides structural equality via Equal interface
// This enables proper Atom.family memoization with type safety
const fetchBrandsAtomFamily = Atom.family((key: FetchBrandsKey) => {
  return RuntimeClientAtom.atom(
    Effect.gen(function* () {
      const { page, alphabetFilter, searchFilter } = key;

      return yield* requestBrands(alphabetFilter, searchFilter, page, brandsPerPageDefault);
    })
  ).pipe(Atom.keepAlive);
});

// Helper function to create fetch atom with clean API
export const fetchBrandsByPageAtom = (
  page: number,
  alphabetFilter: string | null,
  searchFilter: string | null
) => {
  const key = FetchBrandsKey({ page, alphabetFilter, searchFilter });

  return fetchBrandsAtomFamily(key);
};
